import type { MoreActions } from '@confluence/content-types-header/entry-points/MoreActions.tsx';

import { ContentTypesActionsService } from './content-types-actions-service.ts';

export const contentMoreActionsService = new ContentTypesActionsService<MoreActions>();
